export enum ButtonType {
    BUTTON = 'button',
    LINK = 'link',
    SUBMIT = 'submit',
    RESET = 'reset',
    DOWNLOAD = 'download',
    EXTERNAL = 'external',
}

export enum Method {
    GET = 'get',
    POST = 'post',
    PUT = 'put',
    PATCH = 'patch',
    DELETE = 'delete',
}

export enum DocumentType {
    OFFERS = 'offers',
    INVOICES = 'invoices',
    CREDITNOTES = 'creditnotes',
    RECURRINGINVOICES = 'recurringinvoices',
    PURCHASE_BORDERELLES = 'purchase_borderelles',
    PURCHASE_BORDERELLE_CREDITNOTES = 'purchase_borderelle_creditnotes',
}

export enum LinkTarget {
    BLANK = '_blank',
    SELF = '_self',
    PARENT = '_parent',
    TOP = '_top',
}

export enum EntityTypeCreation {
    NONE = 'none',
    NEW = 'new',
    EXISTING = 'existing', // Only if the entity already has values
}
